import { format, zonedTimeToUtc } from "date-fns-tz";

export const APP_TIMEZONE = "Europe/Berlin";

const not_available = "- - -";
export const getEuro = (wert, cent = true) => {
  if ((!wert && typeof wert !== "number") || Number.isNaN(Number(wert))) {
    return not_available;
  }

  if (typeof wert === "string") {
    wert = parseFloat(wert);
  }
  // round wert to 2 decimals, ensure -0 is converted to 0
  wert = parseFloat(wert.toFixed(2)) + 0;
  return wert.toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: cent ? 2 : 0,
    maximumFractionDigits: cent ? 2 : 0,
  });
};

export const getDatum = (timestamp) => {
  let result = not_available;
  if (!isNaN(Date.parse(timestamp)))
    result = format(
      zonedTimeToUtc(new Date(timestamp), APP_TIMEZONE),
      "dd.MM.yyyy"
    );
  return result;
};

export const formatDatePeriod = (from, to, options = { format: "short" }) => {
  let result = not_available;
  const { format = "" } = options;

  // short format
  if (format === "short") {
    // if from == to, only show from
    if (from === to) {
      return getDatum(from);
    }
    // if from and to are the same day, only show from
    if (getDatum(from) === getDatum(to)) {
      return getDatum(from);
    }
    // if from and to are the same month, show day of from and month of to
    if (getDatum(from).split(".")[1] === getDatum(to).split(".")[1]) {
      const from_day = getDatum(from).split(".")[0];
      return `${from_day}. - ${getDatum(to)}`;
    }

    // if from and to are the same year,
    // show day and month of both but year only of "to"
    if (getDatum(from).split(".")[2] === getDatum(from).split(".")[2]) {
      const f = getDatum(from).split(".");
      const from_day_month = f[0] + "." + f[1];
      return `${from_day_month}. - ${getDatum(to)}`;
    }

    // otherwise show from and to
    return `${getDatum(from)} - ${getDatum(to)}`;
  }

  return result;
};

const FILE_SIZE_UNITS = ["B", "KB", "MB", "GB"];

export const getFileSize = (bytes) => {
  if (bytes === null || bytes === undefined || Number.isNaN(Number(bytes))) {
    return not_available;
  }

  let value = Number(bytes);
  let unit_index = 0;
  while (value >= 1024 && unit_index < FILE_SIZE_UNITS.length - 1) {
    value /= 1024;
    unit_index++;
  }

  const decimals = unit_index === 0 ? 0 : 1;
  return `${value.toLocaleString("de-DE", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })} ${FILE_SIZE_UNITS[unit_index]}`;
};

export const getDatumSortable = (timestamp) => {
  let result = not_available;
  if (!isNaN(Date.parse(timestamp)))
    result = format(
      zonedTimeToUtc(new Date(timestamp), APP_TIMEZONE),
      "yyyyMMddHHmmss"
    );
  return result;
};

export const getDatumZeit = (timestamp) => {
  let result = not_available;
  if (!isNaN(Date.parse(timestamp)))
    result = format(
      zonedTimeToUtc(new Date(timestamp), APP_TIMEZONE),
      "dd.MM.yyyy HH:mm"
    );
  return `${result} Uhr`;
};

export const calcSB = function (
  rechnungsbetrag = 0,
  sbProzent = 0,
  sbMin = 0,
  sbMax = 0,
  sbFix = 0
) {
  if (sbFix > 0) {
    return sbFix; // Fester Betrag hat Vorrang
  }

  if (!sbMin || !sbMax || !sbProzent || !rechnungsbetrag) {
    return null;
  }

  const sbBetrag = (rechnungsbetrag / 100) * sbProzent;

  if (sbBetrag < sbMin) {
    return sbMin; // Mindestwert
  }

  if (sbBetrag > sbMax) {
    return sbMax; // Höchstwert
  }

  return sbBetrag; // Berechneter Betrag
};

export const getSbLabel = (sbProzent = 0, sbMin = 0, sbMax = 0, sbFix = 0) => {
  let label = "Selbstbeteiligung";

  if (sbFix > 0) {
    label = `Selbstbeteiligung (fix)`;
  }

  if (sbMax && sbProzent) {
    label = `Selbstbeteiligung (${sbProzent}%, ${getEuro(sbMin, false)} - ${getEuro(sbMax, false)})`;
  }

  return label;
};
